import './style.css';

import backgroundImageHome from '../../assets/img/front_1.jpg';


const Home = ({ currentLanguage }) => {
    return (
        <>
            <section id="home" className="home d-flex align-items-center" style={{backgroundImage: `url(${backgroundImageHome})`}}>
                <div className="container" data-aos="zoom-out" data-aos-delay="100">
                    {/* <h1>Welcome to <span>BizLand</span></h1>
                    <h2>We are team of talented designers making websites with Bootstrap</h2>
                    <div className="d-flex">
                        <a href="#about" className="btn-get-started scrollto">Get Started</a>
                        <a href="https://www.youtube.com/watch?v=jDDaplaOz7Q" className="glightbox btn-watch-video"><i className="bi bi-play-circle"></i><span>Watch Video</span></a>
                    </div> */}
                </div>
            </section>
        </>
    )
}

export default Home;